<template>
    <div id="sidebar">
        <router-link v-for="link in links" :to="link.url" v-bind:key="link.url">
            <div class="sidebar-link">
                <img :src="$route.path === link.url ? link.iconActive : link.icon"/>
                <p class="mt-3">{{link.title}}</p>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',
    data(){
        return {
            links: (config.VUE_APP_REGISTRODESHABILITADO ? [] : [
                {
                    title: 'Registro de solicitud',
                    icon: require('../assets/certification.svg'),
                    iconActive: require('../assets/certification-active.svg'),
                    url: '/solicitud-certificado'
                }
            ]).concat([
                {
                    title: 'Seguimiento de solicitud',
                    icon: require('../assets/tracing.svg'),
                    iconActive: require('../assets/tracing-active.svg'),
                    url: '/seguimiento'
                }
            ])
        }
    }
}
</script>

<style>
#sidebar a {
    text-decoration: none;
}
.sidebar-link{
    height: 186px;
    padding: 32px 22px;
    font-family: 'ProximaNova-Semibold';
    font-size: 15px;
    color: #4f5e6d;
}
.sidebar-link img {
    width: 45%;
}

.sidebar-link p:after {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 2px;
    background-color: #034087;
    margin-top: 7px;
}

.router-link-exact-active > .sidebar-link {
    color: #fff;
    background-color: #EB0029;
}

.router-link-exact-active > .sidebar-link p:after {
    background-color: #ffffff;
}

</style>